<template>
  <div class="SectionPersonelManagment">
    <box :title="$t('nav-section-personel-management')">
      <div class="pa-2">
        <v-row>
          <v-col sm="6">
            <div class="d-flex">
              <label class="center ml-2" for="personelList"
                >{{ $t("personelList") }}:
              </label>
              <v-autocomplete
                v-model="selectedPersonel"
                :items="personels"
                dense
                hide-details=""
                :label="$t('personelList')"
                solo
                item-text="PersonName"
                item-value="PERNO"
              ></v-autocomplete>
            </div>
            <div class="d-flex mt-2">
              <label class="center ml-2" for="sectionType"
                >{{ $t("sectionType") }}:
              </label>
              <v-select
                hide-details
                v-model="sectionType"
                :items="sectionTypes"
                :label="$t('sectionType')"
                item-text="Name"
                item-value="Code"
                return-object
                dense
                solo
                v-on:change="changeSectionType"
                class="my-auto py-0"
                :disabled="isFreeOfGroupManager"
              ></v-select>
            </div>
            <div>
              <v-checkbox
                v-model="isFreeOfGroupManager"
                :label="$t('isFreeOfGroupManager')"
              />
            </div>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addManager">{{
            $t("addManager")
          }}</v-btn>
          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>

    <admin-list class="mt-2" :list="adminsList" @onClickAdmin="onClickAdmin" />
    <details-admin-section
      v-show="pnlAdminDetailVisible"
      class="mt-2"
      :sectionTypes="sectionTypes"
      ref="DetailsAdminSection"
      @search="search"
    />
  </div>
</template>

<script>
import AdminList from "../../../components/admin/sectionPersonel/AdminList.vue";
import DetailsAdminSection from "../../../components/admin/sectionPersonel/DetailsAdminSection.vue";
import EosToastType from "../../../model/EosToastType";
import ResultType from "../../../model/ResultType";
import TextUtils from "../../../utils/TextUtils";
export default {
  components: { AdminList, DetailsAdminSection },
  data() {
    return {
      selectedPersonel: "",
      personels: [],
      sectionType: "",
      sectionTypes: [],

      isFreeOfGroupManager: false,
      adminsList: [],
      pnlAdminDetailVisible: false,
      selectedAdminArgs: {},
    };
  },
  mounted() {
    this.getAllSection();
    this.LoadPersonelList();
    this.search();
  },
  methods: {
    LoadPersonelList() {
      var params = {
        sectionCode: this.sectionType?.Code?.toString().trim() || "-1",
      };
      this.$store.dispatch("GetSectionPersons", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.personels = result.data.Table1;
        }
      });
    },
    getAllSection() {
      debugger
      this.sectionTypes.splice(0);
      this.sectionTypes.push({ Name: this.$t("choose"), Code: "0" });
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "-1" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          //this.search();
        }
      });
    },
    changeSectionType() {},
    async addManager() {
      this.pnlAdminDetailVisible = false;
      if (this.sectionType.Code == "0" && !this.isFreeOfGroupManager) {
        //lblError.Text = Properties.eosWinKartWebResource.addSectionManagerGroup;
        return;
      }

      if (!this.selectedPersonel) {
        //lblError.Text = Properties.eosWinKartWebResource.SelectPernoForSection;
        return;
      }

      var perno = TextUtils.convertToEnglishDigits(
        this.selectedPersonel.toString().trim()
      );
      await this.$store.dispatch("sections/IsOutOfGroup", { perno }).then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          if (result.data) {
            //lblError.Text = Properties.eosWinKartWebResource.registeredForOutOfGroupAdmin;
            return;
          }
        }
      });

      var sectionCode = this.sectionType.Code;

      if (this.isFreeOfGroupManager) {
        await this.$store
          .dispatch("sections/GetAdminSectionCode", { perno })
          .then((result) => {
            //console.log(result);
            if (result.type == ResultType.success) {
              if (result.data.Table.length > 0) {
                //lblError.Text = Properties.eosWinKartWebResource.registerdAdmin;
                return;
              } else {
                sectionCode = "-1";
              }
            }
          });
      }

      await this.$store
        .dispatch("sections/IsDublicatedAdmin", { perno, sectionCode })
        .then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            if (result.data) {
              //lblError.Text = Properties.eosWinKartWebResource.repetedFunction;
              return;
            } else {
              this.AddSectionAdmin(perno, sectionCode);
            }
          }
        });
    },
    AddSectionAdmin(perno, sectionCode) {
      this.$store
        .dispatch("sections/AddSectionAdmin", { perno, sectionCode })
        .then((result) => {
          //console.log(result);

          if (result.type == ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
            this.search();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: this.$t("operationFailed"),
            });
          }
        });
    },
    search() {
      this.pnlAdminDetailVisible = false;
      this.GetAdmins();
    },
    GetAdmins() {
      this.$store.dispatch("sections/GetAdmins").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.adminsList = result.data.Table1;
        }
      });
    },
    onClickAdmin(item) {
      //console.log(item);
      this.isFreeOfGroupManager = false;
      this.ShowDetail(item.id, item.PERNO, item.AdminSectionCode);
    },
    ShowDetail(id, perno, sectionCode) {
      //console.log(id, perno, sectionCode);

      this.selectedAdminArgs = {
        id: id,
        perno: perno,
        sectionCode: sectionCode,
      };
      this.pnlAdminDetailVisible = true;
      this.$refs.DetailsAdminSection.setArgs(this.selectedAdminArgs);
    },
  },
};
</script>

<style>
</style>